import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import queryString from 'query-string';

import PasswordResetResetForm from './PasswordReset/ResetForm';
import PasswordResetChangeForm from './PasswordReset/ChangeForm';

import { hideZendeskWebWidget } from '../helpers';
import { getLogoUrl } from '../helpers/App';

class PasswordReset extends PureComponent {
  componentDidMount() {
    hideZendeskWebWidget();
  }

  getToken() {
    const { location } = this.props;
    const queryVars = queryString.parse(location.search);
    return queryVars.token || false;
  }

  isActivation() {
    const { location } = this.props;
    const queryVars = queryString.parse(location.search);
    return !!(queryVars.activate || false);
  }

  isUserActivation() {
    const { location } = this.props;
    const queryVars = queryString.parse(location.search);
    return !!(queryVars.user_activate || false);
  }

  passwordExpired() {
    const { location } = this.props;
    const queryVars = queryString.parse(location.search);
    return !!queryVars.expired;
  }

  render() {
    return (
      <div className="layout layout-login">
        <div className="login-wrapper">
          <div className="login-inner">
            <div className="login-logo">
              <img src={getLogoUrl()} alt="" />
              {this.getToken() ? (
                <PasswordResetChangeForm
                  token={this.getToken()}
                  passwordExpired={this.passwordExpired()}
                  isActivation={this.isActivation()}
                  isUserActivation={this.isUserActivation()}
                />
              ) : (
                <PasswordResetResetForm />
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

PasswordReset.propTypes = {
  location: PropTypes.object.isRequired,
};

export default connect()(PasswordReset);
